import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'

const RootPage = React.lazy(() => import('modules/payroll_bundle/pages/settings/RootPage'))

const SilaeApiIntegration = React.lazy(
  () => import('modules/integrations_silae_api/pages/Settings')
)
const TimeReimbursementSettings = React.lazy(
  () => import('modules/payroll_bundle/components/settings/TimeReimbursementSettings')
)
const PayrollBundleSettings = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/SettingsPage')
)
const A3nomIntegration = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/A3nomIntegration')
)
const DatevIntegration = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/DatevIntegration')
)
const ExpensesReimbursementSettings = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/ExpensesReimbursement')
)
const IncidencesPage = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/IncidencesPage')
)
const PaierhIntegration = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/PaierhIntegration')
)
const YeapPaierhIntegration = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/YeapPaierhIntegration')
)
const PolicySettingsPage = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/PolicySettingsPage')
)
const SilaeIntegration = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/SilaeIntegration')
)
const ZucchettiIntegration = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/ZucchettiIntegration')
)
const GispagheIntegration = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/GispagheIntegration')
)
const A3innuvaIntegration = React.lazy(
  () => import('modules/payroll_integrations_a3innuva/pages/Settings')
)
const DatevApiIntegration = React.lazy(
  () => import('modules/payroll_integrations_datev_api/pages/Settings')
)

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.payroll_bundle.path,
      element: <RootPage />,
      handle: {
        meta: () => getSettingPageMeta(navigation, 'payroll'),
      },
      children: [
        {
          index: true,
          element: <PayrollBundleSettings />,
        },
        {
          path: navigation.settings.payroll_bundle.expensesReimbursement.path,
          element: <ExpensesReimbursementSettings />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.apps.payroll_bundle.settings.external_supplements.expenses_reimbursement'
              ),
            }),
          },
        },
        {
          path: navigation.settings.payroll_bundle.timeReimbursement.path,
          element: <TimeReimbursementSettings />,
          handle: {
            meta: () => ({
              title: i18n.t('settings.payroll_bundle.connected_supplements.time_categories.title'),
            }),
          },
        },
        {
          path: navigation.settings.payroll_bundle.integrationA3innuva.path,
          element: <A3innuvaIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_a3innuva.general.title'
              ),
              illustration: 'smart-document',
            }),
          },
        },
        {
          path: navigation.settings.payroll_bundle.integrationA3nom.path,
          element: <A3nomIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_a3nom.general.title'
              ),
              description: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_a3nom.general.description'
              ),
              illustration: 'smart-document',
            }),
          },
        },
        {
          path: navigation.settings.payroll_bundle.integrationDatev.path,
          element: <DatevIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_datev.general.title'
              ),
              description: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_datev.general.description'
              ),
              illustration: 'smart-document',
            }),
          },
        },
        {
          path: navigation.settings.payroll_bundle.integrationDatevApi.path,
          element: <DatevApiIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_datev_api.general.title'
              ),
              description: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_datev_api.general.description'
              ),
              illustration: 'smart-document',
            }),
          },
        },
        {
          path: navigation.settings.payroll_bundle.integrationZucchetti.path,
          element: <ZucchettiIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_zucchetti.general.title'
              ),
              description: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_zucchetti.general.description'
              ),
              illustration: 'smart-document',
            }),
          },
        },
        {
          path: navigation.settings.payroll_bundle.integrationPaierh.path,
          element: <PaierhIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_paierh.general.title'
              ),
            }),
          },
        },
        {
          path: navigation.settings.payroll_bundle.integrationYeapPaierh.path,
          element: <YeapPaierhIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_yeap_paierh.general.title'
              ),
            }),
          },
        },
        {
          path: navigation.settings.payroll_bundle.integrationYeapPaierh.path,
          element: <YeapPaierhIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_yeap_paierh.general.title'
              ),
            }),
          },
        },
        {
          path: navigation.settings.payroll_bundle.integrationSilae.path,
          element: <SilaeIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_silae.general.title'
              ),
              description: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_silae.general.description'
              ),
              illustration: 'smart-document',
            }),
          },
        },
        {
          path: navigation.settings.payroll_bundle.integrationSilaeApi.path,
          element: <SilaeApiIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_silae_api.general.title'
              ),
              description: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_silae_api.general.description'
              ),
              illustration: 'smart-document',
            }),
          },
        },
        {
          path: navigation.settings.payroll_bundle.integrationGispaghe.path,
          element: <GispagheIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_gispaghe.general.title'
              ),
              description: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_gispaghe.general.description'
              ),
              illustration: 'smart-document',
            }),
          },
        },
        {
          path: navigation.settings.payroll_bundle.incidences.path,
          element: <IncidencesPage />,
          handle: {
            meta: () => ({
              title: i18n.t('app_store_v2.apps.payroll_bundle.settings.incidences.settings'),
            }),
          },
        },
        {
          path: navigation.settings.payroll_bundle.policies.path,
          element: <PolicySettingsPage />,
          handle: {
            meta: () => ({
              title: i18n.t('app_store_v2.apps.payroll_bundle.settings.payroll_policy.page_title'),
            }),
          },
        },
      ],
    },
  ]
}

export default settingsRoutes
